import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DuplicateContentModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DuplicateContentModalContainer" */
      './DuplicateContentModalContainer'
    ),
  loading: LoadingModal,
});
